module.exports = __webpack_public_path__ + "img/cjcl3.aca75797.png";